/* eslint-disable prefer-promise-reject-errors,no-undef */
import {tryGetDeviceId, readCookie, isDeviceInMiniProgramWebview, throttle} from './utils'

import axios from 'axios'

let authIng = false

function tryGetWebToken () {
  let cookieName = 'wx_t'
  return readCookie(cookieName)
}

const ajaxInstance = axios.create()

let redirectToLoginPage = function (redirectUrl) {
  if (!authIng) {
    authIng = true
    console.log('redirecting....')
    let toRedirect = location.href
    if (redirectUrl && (redirectUrl.lastIndexOf('http') === 0 || redirectUrl.lastIndexOf('/pages/') === 0)) {
      toRedirect = redirectUrl
    }
    console.log(toRedirect)
    if (window['token'] || window.__wxjs_environment === 'miniprogram') {
      toRedirect = toRedirect.replace(/(^\?|&)token=[^&]*/g, '')
      let redirect = encodeURIComponent(toRedirect)
      wx.miniProgram.navigateTo({
        url: '/pages/h5_login_redirect/h5_login_redirect?redirect_url=' + redirect
      })
    } else {
      // location.href = '/login?redirect_url=' + redirect
      location.replace('/login?redirect_url=' + encodeURIComponent(toRedirect))
    }
    authIng = false
  }
}

ajaxInstance.interceptors.request.use(function (config) {
  // Do something before request is sent
  console.log('intercept request: ', config)
  if (!config['headers']) {
    config['headers'] = {}
  }
  if (window['token'] || window.__wxjs_environment === 'miniprogram') {
    if (window['token']) {
      config['headers']['Authorization'] = 'WeApp token=' + window['token']
    }
    config['headers']['User-From'] = 'appservice'
  } else if (!isDeviceInMiniProgramWebview()) {
    // 在小程序的webview，不需要传web token
    let webToken = tryGetWebToken()
    if (webToken) {
      config['headers']['Authorization'] = 'Web token=' + webToken
    }
  }

  config['headers']['Device-Id'] = tryGetDeviceId()
  return config
}, function (error) {
  // Do something with request error
  return Promise.reject(error)
})

// Add a response interceptor
// 解析 返回结果, 按照json schema的格式解析
ajaxInstance.interceptors.response.use((response) => {
  let data = response.data
  if (!data.status) {
    if (data['code'] === 400) {
      return Promise.reject({
        code: data.code,
        message: data.message
      })
    }
    return data
  }
  console.log('ajax data')
  console.log(data)
  switch (data.status) {
    case 'success':
      return data.data
    case 'error':
      if (data.code === 401) {
        throttle(redirectToLoginPage(data.message), 1000)
      }
      return Promise.reject({
        code: data.code,
        message: data.message
      })
    default:
      return response
  }
}, (error) => {
  console.log('ajax errror')
  console.log(error)
  if (error.response) {
    if (error.response.status === 401) {
      throttle(redirectToLoginPage(error.response.data.message), 1000)
    }
    return Promise.reject({
      code: error.response.data.code,
      message: error.response.data.message
    })
  } else {
    return Promise.reject({
      code: 500,
      message: error.toString()
    })
  }
})

export function ajaxAxiosGet (url, data, cb, errCb) {
  ajaxAxiosGetP(url, data).then((response) => {
    cb && cb(response)
  }).catch((error) => {
    errCb && errCb(error)
  })
}

export function ajaxAxiosGetP (url, data) {
  return ajaxRequest(url, data, 'GET')
}

export function ajaxAxiosPost (url, data, cb, errCb) {
  return ajaxAxiosPostP(url, data).then((response) => {
    cb && cb(response)
  }).catch((error) => {
    errCb && errCb(error)
  })
}

export function ajaxAxiosPostP (url, data) {
  return ajaxRequest(url, data, 'POST')
}

export function ajaxAxiosPutP (url, data) {
  return ajaxRequest(url, data, 'PUT')
}

function ajaxRequest (url, data, method) {
  let requestConfig = {
    url: url,
    data: data,
    method: method
  }
  if (!requestConfig['headers']) {
    requestConfig['headers'] = {}
  }
  if (window['token'] || window.__wxjs_environment === 'miniprogram') {
    if (window['token']) {
      requestConfig['headers']['Authorization'] = 'WeApp token=' + window['token']
    }
    requestConfig['headers']['User-From'] = 'appservice'
  } else if (!isDeviceInMiniProgramWebview()) {
    // 在小程序的webview，不需要传web token
    let webToken = tryGetWebToken()
    if (webToken) {
      requestConfig['headers']['Authorization'] = 'Web token=' + webToken
    }
  }

  requestConfig['headers']['Device-Id'] = tryGetDeviceId()

  return ajaxInstance.request(requestConfig)
}



// WEBPACK FOOTER //
// ./src/libs/ajax.js